import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["html", "modifier"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { parseTextBlock } from '../../helpers';
import Wrapper from '../Wrapper';
import TextBlockRender from './TextBlockRender';
import BlazeLink from '../BlazeLink';
import getClassModifiers from '../../utils/get-class-modifiers';
const TextBlock = _ref => {
  let {
      html,
      modifier
    } = _ref,
    variableProps = _objectWithoutProperties(_ref, _excluded);
  if (!html) return null;
  const parsedTextBlock = parseTextBlock({
    html,
    LinkWrapper: BlazeLink
  });
  const modifiers = getClassModifiers('textBlock', _objectSpread({
    modifier
  }, variableProps));

  // todo: the BLAZE_PB_TEXTBLOCK_WRAPPER_ENABLE flag is depreciated. Remove when appropriate
  const className = process.env.BLAZE_PB_TEXTBLOCK_WRAPPER_ENABLE === 'true' ? 'page-content' : '';
  const textRender = /*#__PURE__*/React.createElement(TextBlockRender, _extends({
    parsedTextBlock: parsedTextBlock
  }, variableProps));
  if (!className && !modifiers) return textRender;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    modifiers: modifiers
  }, textRender);
};
TextBlock.propTypes = {
  html: PropTypes.string,
  modifier: PropTypes.string,
  gtmClassName: PropTypes.string,
  elementTitle: PropTypes.string
};
TextBlock.defaultProps = {
  modifier: '',
  gtmClassName: '',
  elementTitle: '',
  html: ''
};
export default TextBlock;
//# sourceMappingURL=index.js.map